// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

require('../../../../core/js/plugins/mtc_slick')

// vanz homepage specific JS
require('../site_scripts/mtc_latest_image_ctas')
require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_make_model_search')
require('../site_scripts/mtc_carz_footer_menu_trigger')
require('../site_scripts/mtc_scroll_to_section')
require('../site_scripts/mtc_read_more')
require('../site_scripts/mtc_vanz_featured')

// vanz homepage specific styles
require('../../css/vanz_homepage.less')